export default {
  type: "row",
  style: "",
  data: {
    applyImageTo: "row",
    applyBackgroundTo: "row",
    stackOnMobile: "off",
  },
  children: [
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-3",
      children: [],
    },
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-6",
      children: [],
    },
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-3",
      children: [],
    },
  ],
};
